import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PasswordSetConfirmationComponent } from './password-set-confirmation/password-set-confirmation.component';
import { PasswordSetComponent } from './password-set/password-set.component';
import { PasswordResetConfirmationComponent } from './password-reset-confirmation/password-reset-confirmation.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';

const routes: Routes = [
    {
        path: 'reset',
        component: PasswordResetComponent,
        pathMatch: 'full',
        data: {
            colouredBackground: false,
            offset: false,
            showMenu: false,
            showHeader: false,
            showFooter: false,
            disableAuthTimeout: false,
        },
    },
    {
        path: 'reset/confirmation',
        component: PasswordResetConfirmationComponent,
        pathMatch: 'full',
        data: {
            colouredBackground: false,
            offset: false,
            showMenu: false,
            showHeader: false,
            showFooter: false,
            disableAuthTimeout: false,
        },
    },
    {
        path: 'set/:Id',
        component: PasswordSetComponent,
        pathMatch: 'full',
        data: {
            colouredBackground: false,
            offset: false,
            showMenu: false,
            showHeader: false,
            showFooter: false,
            disableAuthTimeout: false,
        },
    },
    {
        path: 'confirmation',
        component: PasswordSetConfirmationComponent,
        pathMatch: 'full',
        data: {
            colouredBackground: false,
            offset: false,
            showMenu: false,
            showHeader: false,
            showFooter: false,
            disableAuthTimeout: false,
        },
    },

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthResetRoutingModule {
}
